'use client';

import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface CarAccessoriesProps {
    accessories: (string | null)[];
}

const COLLAPSED_COUNT = 12;

const CarAccessories = ({ accessories }: CarAccessoriesProps) => {
    const [expanded, setExpanded] = useState(false);

    const validAccessori = Array.isArray(accessories)
        ? accessories.filter((item): item is string => !!item && item.trim() !== '')
        : [];

    const visible = expanded ? validAccessori : validAccessori.slice(0, COLLAPSED_COUNT);
    const hasMore = validAccessori.length > COLLAPSED_COUNT;

    if (validAccessori.length === 0) {
        return null;
    }

    return (
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            <div className="flex items-center justify-between mb-5">
                <h2 className="text-sm font-bold text-gray-900 uppercase tracking-widest">Accessori</h2>
                <span className="text-xs font-semibold text-primary bg-primary/10 px-2.5 py-1 rounded-full">
                    {validAccessori.length}
                </span>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-0">
                {visible.map((item, idx) => (
                    <li
                        key={idx}
                        className="flex items-start gap-2 py-2 border-b border-gray-50 last:border-0"
                    >
                        <svg className="shrink-0 mt-0.5 text-primary" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="7" cy="7" r="7" fill="currentColor" fillOpacity="0.15" />
                            <path d="M4 7L6.2 9.2L10 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <span className="text-xs text-gray-700 leading-relaxed">{item}</span>
                    </li>
                ))}
            </ul>

            {hasMore && (
                <button
                    onClick={() => setExpanded(v => !v)}
                    className="mt-4 flex items-center gap-1.5 text-xs font-semibold text-primary hover:text-primary/80 transition-colors"
                >
                    {expanded ? (
                        <>Mostra meno <ChevronUp size={14} /></>
                    ) : (
                        <>Mostra tutti ({validAccessori.length - COLLAPSED_COUNT} altri) <ChevronDown size={14} /></>
                    )}
                </button>
            )}
        </div>
    );
};

export default CarAccessories;
